export const PRODUCTS = [
  {
    slug: "crema-mani",
    img: "/images/crema-mani-hero.jpg",
    gallery: ["/images/crema-mani-1.jpg", "/images/crema-mani-2.jpg", "/images/crema-mani-3.jpg"],
    it: {
      name: "Crema mani",
      line: "Gioia Skincare · Mani",
      tagline: "Le mani parlano di noi. Prenditene cura ogni giorno.",
      claim: "La scienza della natura per mani sempre morbide e curate.",
      tags: ["Idratante", "Nutriente", "Protettiva", "Lenitiva"],
      benefits: ["Idrata e nutre in profondità", "Aiuta a proteggere la barriera cutanea", "Rende le mani più morbide e levigate", "Con ingredienti naturali"],
      ingredientsTitle: "Una formula ricca di attivi naturali",
      ingredientsSub: "Per nutrire, proteggere e donare morbidezza.",
      ingredients: [
        ["Olio di mandorle dolci", "Ricco di acidi grassi, aiuta a nutrire e ammorbidire la pelle, migliorandone la morbidezza."],
        ["Aloe barbadensis", "Nota per le sue proprietà idratanti e lenitive, aiuta a mantenere la pelle morbida e confortevole."],
        ["Estratto di calendula", "Con proprietà lenitive ed emollienti, aiuta a donare comfort alla pelle."],
        ["Olio di argan", "Ricco di acidi grassi e vitamina E, contribuisce a nutrire e migliorare l'elasticità della pelle."],
        ["Vitamina E (tocopheryl acetate)", "Potente antiossidante, aiuta a proteggere la pelle dallo stress ossidativo."],
      ],
      resultsTitle: "Risultati visibili",
      resultsSub: "Mani più morbide, idratate e protette.",
      results: [
        ["Idrata in profondità", "Contribuisce a mantenere la pelle delle mani morbida, levigata e confortevole."],
        ["Nutre e ammorbidisce", "Gli oli vegetali aiutano a ristabilire la morbidezza e l'elasticità cutanea."],
        ["Aiuta a proteggere", "Contribuisce a rinforzare la barriera cutanea e a prevenire la secchezza."],
        ["Dona comfort immediato", "Texture leggera, facilmente assorbibile, ideale per l'uso quotidiano."],
      ],
    },
    en: {
      name: "Hand cream",
      line: "Gioia Skincare · Hands",
      tagline: "Our hands speak for us. Take care of them every day.",
      claim: "The science of nature for hands that are always soft and cared for.",
      tags: ["Moisturising", "Nourishing", "Protective", "Soothing"],
      benefits: ["Deeply moisturises and nourishes", "Helps protect the skin barrier", "Leaves hands softer and smoother", "With natural ingredients"],
      ingredientsTitle: "A formula rich in natural actives",
      ingredientsSub: "To nourish, protect and soften.",
      ingredients: [
        ["Sweet almond oil", "Rich in fatty acids, it helps nourish and soften the skin."],
        ["Aloe barbadensis", "Known for its moisturising and soothing properties, it keeps skin soft and comfortable."],
        ["Calendula extract", "Soothing and emollient, it helps bring comfort to the skin."],
        ["Argan oil", "Rich in fatty acids and vitamin E, it helps nourish and improve skin elasticity."],
        ["Vitamin E (tocopheryl acetate)", "A powerful antioxidant that helps protect the skin from oxidative stress."],
      ],
      resultsTitle: "Visible results",
      resultsSub: "Softer, moisturised and protected hands.",
      results: [
        ["Deep hydration", "Helps keep the skin of the hands soft, smooth and comfortable."],
        ["Nourishes and softens", "Plant oils help restore softness and elasticity."],
        ["Helps protect", "Helps strengthen the skin barrier and prevent dryness."],
        ["Instant comfort", "Light, fast-absorbing texture, ideal for daily use."],
      ],
    },
  },
  {
    slug: "crema-viso-arancia-vitamina-c",
    img: "/images/crema-vitc-hero.jpg",
    gallery: ["/images/gioia-skincare-team.jpg"],
    it: {
      name: "Crema viso arancia e vitamina C",
      line: "Gioia Skincare · Linea Nature · Viso",
      tagline: "Per una pelle luminosa, fresca e dall'incarnato uniforme.",
      claim: "La luce della vitamina C, la delicatezza degli ingredienti vegetali.",
      tags: ["Illuminante", "Uniformante", "Ingredienti vegetali"],
      benefits: ["Aiuta a ravvivare la luminosità della pelle spenta", "Contribuisce a uniformare il tono dell'incarnato", "Ideale al mattino, prima della protezione solare", "Formula con ingredienti vegetali"],
      ingredientsTitle: "Gli attivi protagonisti",
      ingredientsSub: "Dalla linea Nature di Gioia Skincare.",
      ingredients: [
        ["Vitamina C", "Antiossidante prezioso per la pelle spenta o dal tono irregolare: aiuta a ravvivare la luminosità e a uniformare l'incarnato."],
        ["Arancia", "Il profumo e l'energia degli agrumi, per un viso fresco e radioso fin dal mattino."],
        ["Ingredienti vegetali", "Una formula pensata per prolungare a casa i risultati dei trattamenti in cabina."],
      ],
      resultsTitle: "Perché sceglierla",
      resultsSub: "Per chi vuole un viso più luminoso ogni giorno.",
      results: [
        ["Pelle più luminosa", "Aiuta a ridare luce alla pelle spenta e stanca."],
        ["Incarnato uniforme", "Contribuisce a migliorare l'aspetto delle discromie e del tono irregolare."],
        ["Routine semplice", "Applicala al mattino su pelle detersa, su viso, collo e décolleté."],
      ],
    },
    en: {
      name: "Orange & vitamin C face cream",
      line: "Gioia Skincare · Nature line · Face",
      tagline: "For radiant, fresh skin and an even complexion.",
      claim: "The glow of vitamin C, the gentleness of plant-based ingredients.",
      tags: ["Brightening", "Evening", "Plant-based"],
      benefits: ["Helps revive the radiance of dull skin", "Helps even out the complexion", "Ideal in the morning, before sunscreen", "Formula with plant-based ingredients"],
      ingredientsTitle: "Key actives",
      ingredientsSub: "From the Gioia Skincare Nature line.",
      ingredients: [
        ["Vitamin C", "A precious antioxidant for dull or uneven skin: helps revive radiance and even out the complexion."],
        ["Orange", "The scent and energy of citrus, for a fresh, glowing face from the morning."],
        ["Plant-based ingredients", "A formula designed to extend at home the results of your salon treatments."],
      ],
      resultsTitle: "Why choose it",
      resultsSub: "For a brighter face, every day.",
      results: [
        ["Brighter skin", "Helps bring light back to dull, tired skin."],
        ["Even complexion", "Helps improve the look of uneven tone."],
        ["Simple routine", "Apply in the morning on clean skin, face, neck and décolleté."],
      ],
    },
  },
  {
    slug: "crema-viso-calendula-pelle-sensibile",
    img: "/images/crema-calendula-hero.jpg",
    gallery: ["/images/gioia-skincare-prodotti.jpg", "/images/gioia-skincare-team.jpg"],
    it: {
      name: "Crema viso calendula pelle sensibile",
      line: "Gioia Skincare · Linea Nature · Viso",
      tagline: "Avvolge, calma e protegge le pelli più delicate.",
      claim: "La dolcezza della calendula per una pelle finalmente in equilibrio.",
      tags: ["Lenitiva", "Protettiva", "Pelle sensibile", "Ingredienti vegetali"],
      benefits: ["Pensata per pelli delicate, reattive o che si arrossano", "Aiuta a lenire e dare comfort", "Protegge senza appesantire", "Formula con ingredienti vegetali"],
      ingredientsTitle: "Gli attivi protagonisti",
      ingredientsSub: "Dalla linea Nature di Gioia Skincare.",
      ingredients: [
        ["Calendula", "Conosciuta da sempre per le sue proprietà lenitive ed emollienti, aiuta a calmare e a donare comfort alla pelle."],
        ["Ingredienti vegetali", "Una formula delicata, pensata per prolungare a casa i risultati dei trattamenti in cabina."],
      ],
      resultsTitle: "Perché sceglierla",
      resultsSub: "Per una pelle calma e confortevole.",
      results: [
        ["Pelle più calma", "Aiuta a ridurre la sensazione di fastidio e arrossamento."],
        ["Comfort quotidiano", "Avvolge la pelle senza appesantirla, mattina e sera."],
        ["Perfetta dopo i trattamenti", "Ideale quando la pelle è più sensibile, anche nei cambi di stagione."],
      ],
    },
    en: {
      name: "Calendula face cream for sensitive skin",
      line: "Gioia Skincare · Nature line · Face",
      tagline: "Wraps, calms and protects the most delicate skin.",
      claim: "The gentleness of calendula for skin that is finally in balance.",
      tags: ["Soothing", "Protective", "Sensitive skin", "Plant-based"],
      benefits: ["Designed for delicate, reactive or redness-prone skin", "Helps soothe and comfort", "Protects without heaviness", "Formula with plant-based ingredients"],
      ingredientsTitle: "Key actives",
      ingredientsSub: "From the Gioia Skincare Nature line.",
      ingredients: [
        ["Calendula", "Long known for its soothing and emollient properties, it helps calm and comfort the skin."],
        ["Plant-based ingredients", "A gentle formula designed to extend at home the results of your salon treatments."],
      ],
      resultsTitle: "Why choose it",
      resultsSub: "For calm, comfortable skin.",
      results: [
        ["Calmer skin", "Helps reduce the feeling of discomfort and redness."],
        ["Daily comfort", "Wraps the skin without weighing it down, morning and night."],
        ["Perfect after treatments", "Ideal when skin is more sensitive, including seasonal changes."],
      ],
    },
  },
];
